import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\GetItemStockSummaryController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockSummaryController.php
* @route '/api/stock/summary'
*/
const GetItemStockSummaryController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockSummaryController.url(options),
    method: 'get',
})

GetItemStockSummaryController.definition = {
    methods: ["get","head"],
    url: '/api/stock/summary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockSummaryController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockSummaryController.php
* @route '/api/stock/summary'
*/
GetItemStockSummaryController.url = (options?: RouteQueryOptions) => {
    return GetItemStockSummaryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockSummaryController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockSummaryController.php
* @route '/api/stock/summary'
*/
GetItemStockSummaryController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockSummaryController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockSummaryController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockSummaryController.php
* @route '/api/stock/summary'
*/
GetItemStockSummaryController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemStockSummaryController.url(options),
    method: 'head',
})

export default GetItemStockSummaryController